import { useEffect, useState } from 'react';
import { useResultStore } from '@components/acca/results/result/resultStoreProvider';
import Tooltip from '@components/acca/results/result/tooltip';
import { ResultType, resultTypeStringMap } from '@domain/constant/acca/test/result/resultType';
import classNames from 'classnames/bind';
import styles from './resultMeter.module.scss';

const cx = classNames.bind(styles);

const Circle = () => {
  return (
    <>
      <svg className={cx('circleWrap')}>
        <circle className={cx('circle', 'yellow')} cx={80} cy={80} r={80} />
        <circle className={cx('circle', 'green')} cx={80} cy={80} r={80} />
        <circle className={cx('circle', 'blue')} cx={80} cy={80} r={80} />
      </svg>
      <span className={cx('text', 'cheerUp')}>
        Cheer
        <br />
        Up
      </span>
      <span className={cx('text', 'good')}>Good</span>
      <span className={cx('text', 'veryGood')}>
        Very
        <br />
        Good
      </span>
    </>
  );
};

const Pointer = ({ resultTypeString }: { resultTypeString: string }) => {
  const [trigger, setTrigger] = useState('');

  useEffect(() => {
    setTrigger(resultTypeString);
  }, [resultTypeString]);

  return (
    <div className={cx('pointerArea')}>
      <svg viewBox={'0 0 20 64'} className={cx('pointer', trigger)}>
        <path d="M0.750176 50.3953C-0.469889 56.6698 2.57683 64.1992 10.4848 64.1992C18.4057 64.1992 21.447 56.6698 20.2318 50.3953L11.6572 1.40753C11.6572 1.40753 11.5015 0.199219 10.4848 0.199219C9.4681 0.199219 9.31239 1.40753 9.31239 1.40753L0.750176 50.3953Z" />
      </svg>
      <div className={cx('pointerCircle')} />
    </div>
  );
};

const TooltipContent = () => {
  return (
    <>
      <div>
        <em>Cheer Up</em>
        <p>
          응시 목표나 방법을 잘 이해하고 있는지 점검해 보세요!
          <br />
          응시 방법을 잘 숙지한 후 다시 한번 응시해 보세요!
        </p>
      </div>
      <div>
        <em>Good</em>
        <p>
          응시 목표나 방법을 충분히 이해했어요! 아쉬운 부분은 없었는지
          <br />
          확인해 보고, 한 번 더 응시를 해보셔도 좋아요!
        </p>
      </div>
      <div>
        <em>Very Good</em>
        <p>응시 목표나 방법을 잘 이해했어요! 그대로 활용해도 좋아요!</p>
      </div>
    </>
  );
};

const titleText = (resultType: ResultType) => {
  switch (resultType) {
    case 'VERY_GOOD':
      return 'Very Good';
    case 'GOOD':
      return 'Good';
    case 'CHEER_UP':
      return 'Cheer Up';
  }
};

const ResultMeter = () => {
  const { accaResultStore } = useResultStore();
  const { accApplyResult } = accaResultStore;

  if (!accApplyResult) return null;

  const resultType = accApplyResult.resultType;

  return (
    <div className={cx('resultMeter', resultTypeStringMap[resultType])}>
      <span className={cx('tooltipArea')}>
        <Tooltip type={'meter'} content={<TooltipContent />} />
      </span>

      <Circle />

      <Pointer resultTypeString={resultTypeStringMap[resultType]} />

      <div className={cx('resultStatus')}>{titleText(resultType)}</div>
    </div>
  );
};

export default ResultMeter;
